<template lang="pug">
v-chip.suus__chip(:ripple="false" :color="tagColor" label link outlined small)
    template(v-slot)
        .d-flex.align-center.justify-center(:style="tagStyles")
            .d-flex.align-center.justify-center
                slot(name="icon")
            .px-1
                slot(name="text") {{ text }}
</template>

<script lang="ts">
import Vue, { PropType } from "vue"

export default Vue.extend({
  name: "Tag",
  props: {
    text: { type: String as PropType<string | null>, required: false },
    color: {
      type: String as PropType<string | null>,
      required: false,
    },
  },
  computed: {
    tagColor(): string | undefined {
      if (this.color === "primary") {
        return this.$vuetify.theme.themes.light.primary?.toString()
      }
      if (this.color === "textColor") {
        return this.$vuetify.theme.themes.light.textColor?.toString()
      }
      return (
        this.color || this.$vuetify.theme.themes.light.textColor?.toString()
      )
    },
    tagStyles(): object {
      return {
        fontFamily: "system-ui !important",
        color: `${this.tagColor} !important`,
        fontWeight: "900 !important",
      }
    },
  },
})
</script>

<style lang="sass" scoped>

.suus__chip
    border-width: 2px
    border-radius: 2px
    padding: 0 4px
</style>
